import { subscribePricePlansEvent } from "@discovery/common-dplus/lib/adobe";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _user } from "@discovery/common-dplus/lib/state";
import * as M from "@discovery/prelude/lib/data/maybe";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { ButtonContainer, DescriptionContainer, Header, PricePlanWrapper, Container, } from "./index.styled";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import { Button, ButtonVariant } from "../../../components/atoms/button";
import { navigateTo } from "../../../utils/common";
import { RenderBlocks } from "../rich-text-data";
export const PricePlannerView = ({ pricePlans, buttonTitleM, read, }) => {
    let branch;
    const [userM] = useGlobalState(_user);
    const userDetails = {
        idM: M.map((user) => user.id, userM),
        anonymousM: M.map((user) => user.attributes.anonymous, userM),
        packagesM: M.chain((user) => user.attributes.packages, userM),
    };
    const isAnonymous = M.fromMaybe(userDetails.anonymousM, false);
    const userId = M.fromMaybe(userDetails.idM, "");
    const userPackage = M.fromMaybe(userDetails.packagesM, [""]);
    const userType = userPackage[0];
    const buttonTitle = M.fromMaybe(buttonTitleM, "");
    const addDecimalPoint = (price, decimalPoint) => {
        const value = price / Math.pow(10, decimalPoint);
        return Math.trunc(value);
    };
    const onPressContinue = (item) => {
        if (isAnonymous) {
            const webAuthRedirectionUrl = read.authService.protocol +
                "://" +
                read.authService.domain +
                `/login?flow=purchase&header=premiumShow&passId=${item.id}`;
            navigateTo(`${webAuthRedirectionUrl}&returnUrl=${window.location.href}`);
        }
        else {
            const selectedPricePeriodForAdobe = item.period;
            subscribePricePlansEvent(item.id, selectedPricePeriodForAdobe, isAnonymous, userType, userId);
            logBranchAdsEventForPurchase(item.id, item.period);
            const protocol = read.authService.protocol;
            const domain = read.authService.domain;
            const premiumReturnURL = window.location.origin + "/premium";
            const url = protocol +
                "://" +
                domain +
                `/login?flow=purchase&header=premiumShow&passId=${item.id}`;
            navigateTo(`${url}&returnUrl=${premiumReturnURL}`);
        }
    };
    const logBranchAdsEventForPurchase = (priceId, period) => {
        const event_and_custom_data = {
            content_id: priceId,
            name: `${"DiscoveryPlus Main" + " " + period}`,
        };
        try {
            branch === null || branch === void 0 ? void 0 : branch.logEvent("PURCHASE", event_and_custom_data, function (err) {
                console.info(err);
            });
        }
        catch (e) {
            console.info(e);
        }
    };
    return (React.createElement(Container, null, pricePlans.map((item) => {
        const price = addDecimalPoint(item.price, item.currencyDecimalPoints);
        const planLabel = item.period.toLowerCase();
        return (React.createElement(PricePlanWrapper, { key: item.price },
            React.createElement(Header, null,
                React.createElement(Typography, { classNameM: M.of("title"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                    React.createElement(React.Fragment, null, "\u20B9")),
                React.createElement(Typography, { classNameM: M.of("title"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                    React.createElement(React.Fragment, null, price)),
                React.createElement(Typography, { classNameM: M.of("title"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                    React.createElement(React.Fragment, null, "/")),
                React.createElement(Typography, { classNameM: M.of("title"), variant: HeaderVariants.headingSix, tag: Tags.h2 },
                    React.createElement(React.Fragment, null, planLabel))),
            React.createElement(DescriptionContainer, null,
                React.createElement(RenderMaybe, null, M.map((b) => (React.createElement(RenderBlocks, { ast: b })), item.description))),
            React.createElement(ButtonContainer, null,
                React.createElement(Button, { children: buttonTitle ? buttonTitle : "Subscribe Now", variant: ButtonVariant.Primary, onClickM: M.of(() => onPressContinue(item)), id: "#subscribeButton", customstyle: "subscribe" }))));
    })));
};

